/** Cover Wikimedia — Costiera Amalfitana */
export const COSTIERA_HERO_BY_SLUG = {
  positano:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Positano_-_Fornillo_beach.jpg/1280px-Positano_-_Fornillo_beach.jpg",
  praiano:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Praiano_%28Costiera_Amalfitana%29.jpg/1280px-Praiano_%28Costiera_Amalfitana%29.jpg",
  furore:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Furore_fjord.jpg/1280px-Furore_fjord.jpg",
  "conca-dei-marini":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Grotta_dello_Smeraldo_%28Conca_dei_Marini%29.jpg/1280px-Grotta_dello_Smeraldo_%28Conca_dei_Marini%29.jpg",
  amalfi:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Amalfi_Duomo.jpg/1280px-Amalfi_Duomo.jpg",
  atrani:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Atrani_%28Costiera_Amalfitana%29.jpg/1280px-Atrani_%28Costiera_Amalfitana%29.jpg",
  ravello:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Ravello_Villa_Rufolo.jpg/1280px-Ravello_Villa_Rufolo.jpg",
  scala:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Scala_%28Amalfi%29.jpg/1280px-Scala_%28Amalfi%29.jpg",
  minori:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Minori_%28Costiera_Amalfitana%29.jpg/1280px-Minori_%28Costiera_Amalfitana%29.jpg",
  maiori:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Maiori_beach.jpg/1280px-Maiori_beach.jpg",
  cetara:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Cetara_harbour.jpg/1280px-Cetara_harbour.jpg",
};
